import { useState } from "react";

interface Props {
  title: string;
}

export default function ShareTools({ title }: Props) {
  const [toast, setToast] = useState("");

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2000);
  };

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const openShare = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
    showToast("已打开分享窗口");
  };

  const btnClass =
    "flex items-center gap-1.5 rounded-md border border-background-200 bg-background-50 px-3.5 py-2 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap";

  return (
    <div className="relative flex flex-wrap items-center gap-2.5">
      <span className="text-sm text-foreground-500 mr-1 flex items-center gap-1.5">
        <i className="ri-share-forward-line" />
        分享
      </span>
      <button type="button" onClick={handleCopy} className={btnClass}>
        <i className="ri-link" />
        复制链接
      </button>
      <button
        type="button"
        onClick={() =>
          openShare(`https://service.weibo.com/share/share.php?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`)
        }
        className={btnClass}
      >
        <i className="ri-weibo-fill text-[#e6162d]" />
        微博
      </button>
      <button
        type="button"
        onClick={() =>
          openShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`)
        }
        className={btnClass}
      >
        <i className="ri-twitter-x-fill" />
        X
      </button>
      <button
        type="button"
        onClick={() =>
          openShare(`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`)
        }
        className={btnClass}
      >
        <i className="ri-qq-fill" />
        QQ空间
      </button>

      {toast && (
        <span className="absolute -top-10 left-0 z-20 rounded-md bg-foreground-900 px-3 py-1.5 text-xs text-background-50 animate-fade-up">
          {toast}
        </span>
      )}
    </div>
  );
}